import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './MessageTemplateRequestInfo.html';
import { Inject } from 'vue-di-container';
import Progress from 'easy-circular-progress';
import contractRequestInfoService from './MessageTemplateRequestInfoService';
import UserService from '../../../shared/userService/UserService';
import { AttachmentModel } from '../../AddRequest/AttachmentModel';
import FileSaver from 'file-saver';
import { Toaster } from '../../../Services/toast';
import moment from 'moment';
import { SenderType } from '../../../shared/Enums/SenderType';
import UserRoleService from '../../../shared/userService/UserRoleService';
import { SenderRequestApprovalHistoryViewModel } from './SenderRequestApprovalHistoryViewModel';
import { SenderRequestExtendViewModel } from './SenderRequestExtendViewModel';
import MessageTemplateRequestInfoService from './MessageTemplateRequestInfoService';
import { MessageTemplateRequestModel } from './MessageTemplateRequestModel';
import MessageTemplateRequestDashboardService from '../MessageTemplateRequestDashboardService';
import { RejectionReasonModel } from '../../RejectionReason/RejectionReasonModel';
import { DropdownModel } from '../../Provider/ProviderModel';

@WithRender
@Component({
    components: {
        Progress,
    }, diProvide: [
        MessageTemplateRequestDashboardService,
        UserService,
        contractRequestInfoService,
        UserRoleService,
    ],
})
export default class MessageTemplateRequestInfo extends Vue {
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    @Prop({ type: Boolean, default: false })
    public isFromDashboard: boolean | any;
    @Prop({ type: String, default: '' })
    public id: string | any;
    public substitutedTemplateContent: string = '';
    public baseTemplateContent: string = '';
    public templateVariables: Array<{ key: string, value: string }> = [];
    public resendComment: string = '';
    public rejectResone: string | null = null;
    public otherRejectResone: string = ''
    public tenantId: string | any;
    public selectedRejectReason: RejectionReasonModel = {} as RejectionReasonModel;
    public selectedRejectReasonList: RejectionReasonModel[] = {} as RejectionReasonModel[];
    @Inject(MessageTemplateRequestDashboardService) public contractDashboardService!: MessageTemplateRequestDashboardService;
    @Inject(MessageTemplateRequestInfoService) public contractRequestInfoService!: MessageTemplateRequestInfoService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    public sender: MessageTemplateRequestModel = {
        id: '',
        displayId: '',
        duration: '',
        senderType: 0,
        newSenderType: 0,
        senderStatus: 0,
        senderId: '',
        startDate: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        providerName: '',
        customerType: 0,
        contractAttachment: null,
        senderName: '',
        requestStatus: 0,
        lastRejectionReason: '',
        remainingDays: 0,
        totalDays: 0,
        comment: '',
        isCriticalSender: false,
        expiryDate: '',
        tenantId: '',
        senderExpiryDate: '',
        automaticallyInserted: false,
        templateName: '',
        templateDescription: '',
        processingDuration: 0,
        processingDurationType: 0,
        templateContent: '',        
        templateStatus: '', 
        classification: '',
        requestType: 0,
        senderRequestAttachments: [],
    };
    public isItOtherReasonPorp: boolean = false;
    public providerLocked: boolean = false;
    public rejectdialog: boolean = false;
    public showSenderRequestTransactionsdialog: boolean = false;
    public showExtendRequestsdialog: boolean = false;
    public isAllSelected: boolean = true;
    public isOtherSelected: boolean = false;
    public deactivateDialog: boolean = false;
    public approveDialog: boolean = false;
    public resendDialog: boolean = false;
    public deleteDialog: boolean = false;
    public deleteComment: string = '';
    public deactivateConfirmMessage: string = '';
    public senderType: SenderType[] = [];
    public SenderRequestTransactions: SenderRequestApprovalHistoryViewModel[] = [];
    public senderRequestExtendViewModel: SenderRequestExtendViewModel[] = [];
    public selectedIds: string[] = [];
    public userRole: any;
    public customerType: string = '';
    public popUpRejectionReasons: RejectionReasonModel[] = [];
    public approveComment: string = '';
    public User: any;
    public getClassificationText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.Advertising').toString();
            case 2:
                return this.$t('shared.Service').toString();
            case 3:
                return this.$t('shared.Warning').toString();
            case 5:
                return this.$t('shared.Awareness').toString();
            default:
                return '-';
        }

    }
    public headers: any = [
        { text: this.$t('senderInfo.requestStatus'), value: 'requestStatus', align: 'center', sortable: false },
        { text: this.$t('senderInfo.createdDate'), value: 'createdDate', align: 'center', sortable: false },
        { text: this.$t('senderInfo.comment'), value: 'rejectionReason', align: 'center', sortable: false },
    ];
    public extendRequestHeaders: any = [
        { text: this.$t('senderInfo.extendRequestId'), value: 'extendRequestId', align: 'center', sortable: false },
        { text: this.$t('senderInfo.duration'), value: 'duration', align: 'center', sortable: false },
        { text: this.$t('senderInfo.requestStatus'), value: 'requestStatus', align: 'center', sortable: false },
        { text: this.$t('senderInfo.createdDate'), value: 'createdDate', align: 'center', sortable: false },
    ];
    public async mounted() {
        this.selectedIds.push(this.id);
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        if (this.userRole === 2 || this.userRole === 5) {
            this.isProviderLocked();
        }
        this.sender = await this.contractRequestInfoService.GetById(this.id, this.isFromDashboard);
        this.sender.senderRequestAttachments = this.sender.senderRequestAttachments || [];
        this.buildTemplateContentDisplay();
        this.userRole = this.GetUserRole();
        this.tenantId = this.User.details.TenantId;
        this.customerType = this.getCustomerTypeText(this.sender.customerType);
        this.getSenderType();
        if (this.userRole === 1 || this.userRole === 9) {
            await this.getRejectionReasons();
        }
        this.selectAllToggle();
    }
    public async isProviderLocked() {
        const response = await this.contractDashboardService.isProviderLocked();
        this.providerLocked = response.result;
    }
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }
    private normalizeTemplateVariableValue(variable: unknown): string {
        if (variable === null || variable === undefined) {
            return '';
        }
        if (typeof variable === 'string') {
            return variable;
        }
        if (typeof variable === 'object') {
            const variableObject = variable as { key?: string, value?: string };
            if (variableObject.key) {
                return variableObject.key;
            }
            if (variableObject.value) {
                return variableObject.value;
            }
        }
        return String(variable);
    }
    private buildTemplateContentDisplay(): void {
        this.substitutedTemplateContent = '';
        this.baseTemplateContent = '';
        this.templateVariables = [];
        if (!this.sender || !this.sender.templateContent) {
            return;
        }
        let text = '';
        let variables: string[] = [];
        try {
            const parsed = JSON.parse(this.sender.templateContent);
            text = parsed.text || '';
            variables = Array.isArray(parsed.variables)
                ? parsed.variables.map((variable: unknown) => this.normalizeTemplateVariableValue(variable))
                : [];
        } catch {
            text = this.sender.templateContent;
            variables = [];
        }
        this.baseTemplateContent = text;
        if (Array.isArray(variables)) {
            for (let i = 0; i < variables.length; i++) {
                this.templateVariables.push({
                    key: '#Var' + (i + 1) + '#',
                    value: variables[i]
                });
            }
        }
        const regex = /#Var(\d+)#/g;
        this.substitutedTemplateContent = text.replace(regex, (match: string, num: string) => {
            const index = parseInt(num, 10) - 1;
            return (variables && variables[index]) ? variables[index] : match;
        });
    }

    public get hasTemplateVariables(): boolean {
        return /#Var\d+#/i.test(this.baseTemplateContent || '');
    }
    public SelectOtherToggle() {
        this.$nextTick(() => {
            if (this.isOtherSelected) {
                this.otherRejectResone = ''
                this.isOtherSelected = false;
                this.isItOtherReasonPorp = false;
            } else {
                this.isOtherSelected = true;
                this.isItOtherReasonPorp = true;
            }
        });
    }
    public get isItOtherReason(): boolean {
        return this.isItOtherReasonPorp;
    }
    public async getRejectionReasons() {
        const response = await this.contractDashboardService.getSenderNameRejectReasons(3);
        this.popUpRejectionReasons = response.result;
        this.popUpRejectionReasons.push({ id: '0', rejectionText: 'other', requestType: 3 })

    } public get rejectReasonIsValid(): boolean {
        return ((this.selectedRejectReasonList.length !== 0 && this.selectedRejectReasonList.length !== undefined) || this.otherRejectResone !== '');
    }
    public get icon() {
        if (this.isAllSelected && this.selectedRejectReasonList.length === this.popUpRejectionReasons.length) {
            return 'check_box';
        }
        if (this.selectedRejectReasonList.length > 0) {
            return 'indeterminate_check_box';
        }
        return 'check_box_outline_blank';
    }
    public get OtherIcon() {
        if (this.isOtherSelected) {
            return 'check_box';
        }
        return 'check_box_outline_blank';
    }
    public selectAllToggle() {
        this.$nextTick(() => {
            if (this.isAllSelected) {
                this.selectedRejectReasonList = [];
                this.rejectResone = null;
                this.isAllSelected = false;
            } else {
                this.isAllSelected = true;
                this.rejectResone = this.popUpRejectionReasons.slice().map((x) => x.rejectionText).toString();
                this.selectedRejectReasonList = this.popUpRejectionReasons.slice();
            }
        });
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getRequestTypeText(typeId: number) {
        switch (typeId) {
            case 9:
                return this.$t('New Message Template').toString();
            case 10:
                return this.$t('Renew Message Template').toString();
            default:
                return '-';
        }
    }

    public getSenderType() {
        const senderBinary = this.sender.senderType;
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public getProcessingDurationText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.normal').toString(); 
            case 2:
                return this.$t('shared.express').toString(); 
            default:
                return '-';
        }
    }
 

    public checkColor(status: string): string {
        switch (status.toString()) {
            case '1':
                return '#c427ba';
            case '2':
                return '#8BC34A';
            case '3':
                return '#C42727';
            case '4':
                return '#aaa7a7';
            case '5':
                return '#014bb1';
            case '6':
                return '#F78500';
            case '7':
                return '#aaa7a7';
            case '8':
                return '#5aaa0b';
            case '11':
                return '#421984';
            default:
                return '#aaa7a7';
        }
    }

    public GetTemplateStatus(typeStatus: string): string {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': return 'Pending Approval';
            case '2': return 'Approved';
            case '3': return 'Rejected';
            case '4': return 'Paid';
            case '5': return 'Expired';
            case '6': return 'Deleted';
            case '7': return 'Pending Payment';
            case '8': return 'Completed';
            case '11': return 'Deactivated';
            default: return '';
        }
    }

    public getTemplateStatusDisplay(status: string): string {
        if (!status) {
            return '-';
        }
        switch (status) {
            case 'Active':
                return this.$t('dashboardPage.active').toString();
            case 'NotActive':
                return this.$t('dashboardPage.inactive').toString();
            default:
                return status;
        }
    }

    public formatApprovalHistoryStatus(status: string): string {
        const statusKey = status.toString();
        if (/^\d+$/.test(statusKey)) {
            return this.GetTemplateStatus(statusKey);
        }
        switch (statusKey) {
            case 'PendingApproval':
                return this.$t('shared.pendingApproval').toString();
            case 'Approved':
                return this.$t('shared.approved').toString();
            case 'Rejected':
                return this.$t('shared.rejected').toString();
            case 'Paid':
                return this.$t('shared.paid').toString();
            case 'Expired':
                return this.$t('shared.expired').toString();
            case 'Deleted':
                return this.$t('shared.deleted').toString();
            case 'PendingPayment':
                return this.$t('shared.pendingPayment').toString();
            case 'Deactivated':
                return this.$t('shared.deactivated').toString();
            case 'ApprovedAndPaid':
                return 'Completed';
            default:
                return statusKey;
        }
    }

    public getRate(startDate: string, duration: string) {
        return (this.remainingDays(startDate, duration) / (parseInt(duration, 10) * 365)) * 100;
    }

    public remainingDays(startDate: string, duration: string): number {
        const todaysdate = moment();
        const expiryDate = moment(startDate).add(parseInt(duration, 10), 'years').calendar();
        const eventdate = moment(expiryDate);
        if (moment(moment(startDate).format('L')).isAfter(moment().format('L'))) {
            return eventdate.diff(moment(startDate), 'days') + 1;
        } else {
            return eventdate.diff(todaysdate, 'days') + 1;
        }
    }

    public expiryDate(startDate: string, duration: string): number {
        const expiryDateString = moment(startDate).add(parseInt(duration, 10), 'years').calendar();
        const eventdate = moment(startDate);
        const expiryDate = moment(expiryDateString);
        return expiryDate.diff(eventdate, 'days') + 1;
    }
    public showresendDialog() {
        this.resendDialog = true;
    }
    public hideresendDialog() {
        this.resendComment = '';
        this.resendDialog = false;
    }
    public showapproveDialog() {
        this.approveComment = '';
        this.approveDialog = true;
    }
    public hideapproveDialog() {
        this.approveDialog = false;
    }
    public async approve() {
        if (this.sender.requestStatus !== 1) {
            Toaster.error(this.$t('dashboardPage.NotAllRequestsPendingApproval').toString());
            return;
        }
        else {
            const response = await this.contractDashboardService.approve(this.selectedIds, this.approveComment);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                Toaster.success(this.$t('dashboardPage.RequestApprovedsuccessfully').toString());
                this.$router.go(0);
            }
        }
    }
    public async resend() {
        if (this.sender.requestStatus.toString() !== '3') {
            Toaster.error(this.$t('dashboardPage.NotAllTemplateRejected').toString());
            return;
        }
        const response = await this.contractDashboardService.resend(this.selectedIds, this.resendComment);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.resentSuccessfully').toString());
        this.hideresendDialog();
        this.$router.go(0);
    }

    public ConectivityDetail(senderId: string) {
        this.$router.push({ name: 'SenderConectivityDetail', params: { senderId } });
    }
    public async hideRejectDialog() {
        this.isAllSelected = false;
        this.isOtherSelected = false;
        this.rejectResone = null;
        this.otherRejectResone = '';
        this.isItOtherReasonPorp = false;
        this.selectedRejectReasonList = [];
        this.rejectdialog = false;
    }
    public async showRejectDialog() {
        this.rejectdialog = true;
    }
    public async reject() {
        if (this.sender.requestStatus.toString() !== '1') {
            Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
            return;
        }
        if (this.selectedRejectReasonList.length !== undefined) {
            this.rejectResone = this.selectedRejectReasonList.slice().map((x) => x.rejectionText).toString();
        }
        this.rejectResone = (this.rejectResone === null || this.rejectResone === '')
            ? this.otherRejectResone
            : this.otherRejectResone != ''
                ? this.rejectResone + ',' + this.otherRejectResone
                : this.rejectResone;
        if (!this.rejectResone) {
            return;
        }
        this.rejectdialog = false;
        const response = await this.contractDashboardService.reject(this.selectedIds, this.rejectResone);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            this.rejectdialog = true;
            return;
        }
        this.rejectResone = '';
        this.selectedIds = [this.id];
        Toaster.success(this.$t('dashboardPage.RequestRejectedsuccessfully').toString());
        this.$router.go(0);
    }
  
    public async showSenderRequestTransactions() {
        var response = await this.contractRequestInfoService.GetRequestApprovalHistory(this.id);
        if (response.isSuccess) {
            this.SenderRequestTransactions = response.result;
            this.showSenderRequestTransactionsdialog = true;
        }
    }

    public async hideshowSenderRequestTransactionsdialog() {
        this.showSenderRequestTransactionsdialog = false;
    }

    public PreparePay() {
        if (this.sender.requestStatus !== 2) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderPendingPay').toString());
            return;
        } else {
            this.$router.push({ name: 'Payment', params: { ids: this.selectedIds.join(',') } });
        }
    }
    public showDeleteDialog() {
        this.deleteComment = '';
        this.deleteDialog = true;
    }
    public hideDeleteDialog() {
        this.deleteDialog = false;
    }
    public async deleteRequest() {
        const response = await this.contractDashboardService.deleteMessageTemplate([this.sender.id]);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.RequestDeletedSuccessfully').toString());
        this.deleteDialog = false;
        this.$router.go(0);
    }
    public showDeactivateDialog() {
        this.deactivateConfirmMessage = this.$t('shared.deactivateInputText').toString();
        this.deactivateDialog = true;
    }
    public hideDeactivateDialog() {
        this.deactivateDialog = false;
    }
    public async deactivate() {
        const response = await this.contractDashboardService.deactivateMessageTemplate([this.sender.id]);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.RequestDeactivatedsuccessfully').toString());
        this.deactivateDialog = false;
        this.$router.go(0);
    }
    public async DownloadFile(file: AttachmentModel) {
        const fileContent = await this.contractRequestInfoService.GetFileContent(file.id);
        const array = Buffer.from(fileContent, 'base64');
        const blob = new Blob([array], { type: 'application/pdf' });
        FileSaver.saveAs(blob, file.fileName);
    }
}
